export default "__VITE_ASSET__9f65bb06__"